// assets
import {
  IconHome,
  IconCalendarEvent,
  IconUsers,
  IconNotebook,
  IconBuildingCommunity,
  IconBed,
  IconFileInvoice,
  IconPhoneCheck,
  IconMessageReport,
  IconClipboardList,
  IconReportAnalytics,
  IconId,
  IconCurrencyRupee,
  IconCheckbox
} from '@tabler/icons-react';
import { Hospital, FolderUp } from 'lucide-react';

const HospitalMenuIcon = ({ stroke, ...props }) => <Hospital {...props} strokeWidth={typeof stroke === 'number' ? stroke : 1.5} />;
const FolderUpIcon = ({ stroke, ...props }) => <FolderUp {...props} strokeWidth={typeof stroke === 'number' ? stroke : 1.5} />;

// constant
const icons = {
  IconHome,
  IconCalendarEvent,
  IconUsers,
  IconNotebook,
  IconBuildingCommunity,
  IconBed,
  IconFileInvoice,
  IconPhoneCheck,
  IconMessageReport,
  IconClipboardList,
  IconReportAnalytics,
  IconId,
  IconCurrencyRupee,
  IconCheckbox,
  Hospital: HospitalMenuIcon,
  FolderUp : FolderUpIcon
};

// // Import SVG icons from assets
// import buildingIcon from '../assets/images/building.svg';
// import bookingIcon from '../assets/images/booking.svg';
// import complaintIcon from '../assets/images/Complaints.svg';
// import attendanceIcon from '../assets/images/Attendance.svg';
// import roomAllotmentIcon from '../assets/images/room2.svg';

// import BedIcon from '../assets/images/Bed.svg';
// import { ClipboardList } from 'lucide-react';

// ==============================|| SUPER ADMIN DASHBOARD MENU ITEMS ||============================== //

const superdashboard = {
  type: 'SuperAdmin',
  children: [
    {
      id: 'default',
      title: 'Dashboard',
      type: 'item',
      url: '/superadmindashboard/default',
      icon: icons.IconHome,
      breadcrumbs: false
    },
    {
      id: 'buildingmanagement',
      title: 'Building & Floor Management',
      type: 'item',
      url: '/superadmindashboard/buildingmanagement',
      icon: icons.IconBuildingCommunity,
      breadcrumbs: false
    },
    {
      id: 'bookingRequest',
      title: 'Booking Request',
      type: 'item',
      url: '/superadmindashboard/booking_request',
      icon: icons.IconCalendarEvent,
      breadcrumbs: false
    },
    {
      id: 'roomAllotment',
      title: 'Room Allotment',
      type: 'item',
      url: '/superadmindashboard/roomallotment',
      icon: icons.IconBed,
      breadcrumbs: false
    },
    {
      id: '02',
      title: 'Room Allocation',
      type: 'item',
      url: '/superadmindashboard/roomallocation',
      icon: icons.IconNotebook,
      breadcrumbs: false
    },
    {
      id: '03',
      title: 'Student Management',
      type: 'item',
      url: '/superadmindashboard/studentmanagement',
      icon: icons.IconUsers,
      breadcrumbs: false
    },
    {
      id: '04',
      title: 'Hostel Attendance',
      type: 'item',
      url: '/superadmindashboard/studentattendance',
      icon: icons.IconClipboardList,
      breadcrumbs: false
    },
    {
      id: '05',
      title: 'Complaint Management',
      type: 'item',
      url: '/superadmindashboard/complaintmanagement',
      icon: icons.IconMessageReport,
      breadcrumbs: false
    },
    {
      id: '06',
      title: 'Reports',
      type: 'item',
      url: '/superadmindashboard/reports',
      icon: icons.IconReportAnalytics,
      breadcrumbs: false
    },
    {
      id: '07',
      title: 'Gate Pass Management',
      type: 'item',
      url: '/superadmindashboard/gatePass',
      icon: icons.IconId,
      breadcrumbs: false
    },
    {
      id: '08',
      title: 'Hospital Complaint Management',
      type: 'item',
      url: '/superadmindashboard/hospital_complaint',
      icon: icons.Hospital,
      breadcrumbs: false
    },
    {
      id: '09',
      title: 'Hospital Complaint Raise',
      type: 'item',
      url: '/superadmindashboard/hospital_complaint_raise',
      icon: icons.Hospital,
      breadcrumbs: false
    },
    {
      id: '12',
      title: 'Fee Management',
      type: 'item',
      url: '/superadmindashboard/fees_management',
      permissionKeys: ['fees_management'],
      icon: icons.IconCurrencyRupee,
      breadcrumbs: false
    },
    {
      id: 'Fee Approval',
      title: 'Fee Approval',
      type: 'item',
      url: '/superadmindashboard/fees_approval',
      icon: icons.IconCheckbox,
      breadcrumbs: false
    },
     {
      id: 'Fee Repot',
      title: 'Fee Report',
      type: 'item',
      url: '/superadmindashboard/fees_repots',
      icon: icons.IconReportAnalytics,
      breadcrumbs: false
    },
     {
      id: 'Fees Upload',
      title: 'Fees Upload',
      type: 'item',
      url: '/superadmindashboard/fees_upload',
      icon: icons.FolderUp,
      breadcrumbs: false
    },
    // {
    //   id: '10',
    //   title: 'Admission Management',
    //   type: 'item',
    //   url: '/superadmindashboard/admission_management',
    //   allowedRoutes: ['/superadmindashboard/admission_form'],
    //   icon: icons.IconUsers,
    //   breadcrumbs: false
    // },
    // {
    //   id: '11',
    //   title: 'Enquiry Management',
    //   type: 'item',
    //   url: '/superadmindashboard/enqury_management',
    //   allowedRoutes: ['/superadmindashboard/enqury_form'],
    //   permissionKeys: ['admission_enquiry_management', 'enquiry_management', 'enqury_management'],
    //   icon: icons.IconPhoneCheck,
    //   breadcrumbs: false
    // }
  ]
};

export default superdashboard;
